// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3221":"fe204016","4220":"d749e5ef","5622":"e9066fd1","5841":"fe204016","6224":"fe204016"}[chunkId] + ".chunk.css";
};